import React from "react"

import PageFooter from "./PageFooter"

const SrfPageFooter = ({ debug, footer_data: footerData }) => {
  return <PageFooter {...footerData} {...{debug}}/>
}

export default SrfPageFooter